import type { IntlShape } from 'react-intl'
import type { PaymentTermHeader } from './types'

export const paymentTermHeaders: PaymentTermHeader[] = [
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Koodi',
				description: 'Table column header: Code',
			}),
		key: 'code', //TODO:
		show: true,
		sortable: true,
		type: 'string',
		fullWidth: true,
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Kuvaus',
				description: 'Table column header: Description',
			}),
		key: 'description', //TODO:
		show: true,
		sortable: true,
		type: 'string',
		fullWidth: true,
	},
]
export const paymentTermFormHeaders: PaymentTermHeader[] = [
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Koodi',
				description: 'Table column header: Code',
			}),
		key: 'code', //TODO:
		show: true,
		sortable: true,
		type: 'string',
		fullWidth: true,
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Kuvaus',
				description: 'Table column header: Description',
			}),
		key: 'description', //TODO:
		show: true,
		sortable: true,
		type: 'string',
		fullWidth: true,
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Nettopäivät',
				description: 'Table column header: Net days',
			}),
		key: 'netDays', //TODO:
		show: true,
		sortable: true,
		type: 'string',
		fullWidth: true,
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Kassa-ale',
				description: 'Table column header: Cash discount',
			}),
		key: 'cashDiscount', //TODO:
		show: true,
		sortable: true,
		type: 'string',
		fullWidth: true,
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Kassa-ale päivät',
				description: 'Table column header: Cash discount days',
			}),
		key: 'cashDiscountDays', //TODO:
		show: true,
		sortable: true,
		type: 'string',
		fullWidth: true,
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Oletus maksuehto',
				description: 'Table column header: Default payment term',
			}),
		key: 'default', //TODO:
		show: true,
		sortable: true,
		type: 'boolean',
		fullWidth: true,
	},
]
